import { render, staticRenderFns } from "./MonitoringTab.vue?vue&type=template&id=219ef4a7&"
import script from "./MonitoringTab.vue?vue&type=script&lang=js&"
export * from "./MonitoringTab.vue?vue&type=script&lang=js&"
import style0 from "./MonitoringTab.vue?vue&type=style&index=0&id=219ef4a7&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports